import rootStore from '@/store/root'

export default {
  getters: {
    props (state, getters) {
      if (getters.path.startsWith('/assets/')) {
        return state._props
      }
      return Object.assign(
        {},
        state._props,
        state._props_locales && state._props_locales[rootStore.getters.contentLocale]
      )
    }
  },
  actions: {
    setProp ({ commit, getters }, { key, value }) {
      commit('setProp', {
        key,
        value,
        locale: getters.path.startsWith('/assets/') ? '' : rootStore.getters.contentLocale
      })
    }
  }
}
